import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Box, Card, Grid, Typography, Stack, IconButton, backdropClasses } from "@mui/material"
import { getRegionDetails } from "../../../../redux/slices/hyperwolf/settings"
import { openSnackbar } from "../../../../redux/slices/common"
// custom components
import CommonLayout from "layouts/DashboardLayout"
import MapWithPolygon from "../../../../components/googleMaps"
import StatusText from "common/component/StatusText"
import MDButton from "components/MDButton"
import AngleRightIcon from "common/customIcons/angle_right";

export default function ViewRegion() {
  const { regionId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const [details, setDetails] = useState({});
  const [selectedSubRegion, setSelectedSubRegion] = useState({});

  const handleRegionDetails = async () => {
    try {
      const response = await dispatch(getRegionDetails(regionId)).unwrap()
      if (response?.data) {
        setDetails(response?.data)
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error?.message || error
      dispatch(openSnackbar({ content: errorMsg, color: "error", icon: "warning", }));
    }
  }

  useEffect(() => {
    handleRegionDetails();
  }, [])

  return (
    <CommonLayout>
      <Box p={{ xs: 2, sm: 3, lg: 4 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={2}
        >
          <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
            <IconButton onClick={() => navigate(-1)}>
              <AngleRightIcon fontSize="14px" />
            </IconButton>
            <Typography variant="body2" fontWeight="semibold" ml={0.75}>
              Regions-Oakland
            </Typography>
          </Box>
        </Stack>

        <Card sx={{ p: { xs: 2, md: 2.5 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Typography variant='body2' fontWeight="normal" color="#656575" mb={1}>Region</Typography>
              <Typography variant='h5' fontWeight="medium" color="#2E2E3A">{details.region}</Typography>
            </Grid>
          </Grid>
        </Card>

        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <Card sx={{ p: { xs: 2, md: 2.5 }, py: { xs: 2, md: 3.5 }, borderRadius: 2.5, boxShadow: "none", minHeight: "470px", height: "100%" }}>
              <Typography variant='h5' fontWeight="bold" color="#2E2E3A" mb={3}>Sub Regions</Typography>
              <ul className="sub-regions-listing">
                {
                  details?.subRegions?.map((subRegion, index) => {
                    return (
                      <li key={index}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={4} key={index}>
                            <Typography variant='body2' fontWeight="normal" color="#656575" mb={1}>Sub Region</Typography>
                            <Typography variant='h5' fontWeight="medium" color="#2E2E3A">{subRegion?.name}</Typography>
                          </Grid>
                          <Grid item xs={12} md={4} key={index}>
                            <Typography variant='body2' fontWeight="normal" color="#656575" mb={1}>KML</Typography>
                            <MDButton
                              sx={{ minWidth: "100px", border: "1px solid #D0D0DA", background: "#F1F1F1" }}
                              type="button"
                              variant="outlined"
                              color="dark"
                              size="small"
                              onClick={() => setSelectedSubRegion(subRegion)}
                              className={selectedSubRegion?.kml === subRegion.kml ? "active-view-link" : ""}
                            >
                              View Link
                            </MDButton>
                          </Grid>
                          <Grid item xs={12} md={4} key={index}>
                            <Typography variant='body2' fontWeight="normal" color="#656575" mb={1}>
                              <StatusText status={subRegion?.status ? "Active" : "Inactive"} style={{ justifyContent: "end" }} />
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12} key={index}>
                            <Typography variant='body2' fontWeight="normal" color="#656575" mb={1}>Assigned Driver Today</Typography>
                            <Typography variant='h5' fontWeight="medium" color="#2E2E3A">{subRegion?.driver}</Typography>
                          </Grid>
                        </Grid>
                      </li>
                    )
                  })
                }
              </ul>
            </Card>
          </Grid>
          {
            selectedSubRegion?.kml && <Grid item xs={12} md={5}>
              <Card sx={{ p: { xs: 2, md: 2.5 }, py: { xs: 2, md: 3.5 }, overflow: "hidden", borderRadius: 2.5, boxShadow: "none", height: "470px" }} className='w-100'>
                <Box display="flex" flexDirection="column" mb={3}>
                  <Typography variant='h5' fontWeight="bold" color="#2E2E3A" mb={1}>KML view for {selectedSubRegion?.name}</Typography>
                  {/* <Typography variant='body2' fontWeight="normal" color="#2E2E3A">{selectedSubRegion.kml}</Typography> */}
                </Box>
                <Box display="flex" flexDirection="column" style={{ borderRadius: "10px", overflow: "hidden" }}>
                  <MapWithPolygon kmlUrl={selectedSubRegion?.kml?.find(kml => kml?.active)?.url} />
                </Box>
              </Card>
            </Grid>
          }
        </Grid>
      </Box>
    </CommonLayout>
  )
}
